// extracted by mini-css-extract-plugin
export default {"queryModalTitle":"styles_queryModalTitle__eZnwA","queryModalTitleContainer":"styles_queryModalTitleContainer__3x6Kp","icon":"styles_icon__+TpoD","info":"styles_info__rOQ32"};